// 4-row tech stack marquee — alternating directions, varying speeds (medium/balanced).
// Logos rendered via simpleicons.org CDN; failed loads gracefully fall back to text.

const ROW_1 = [
  { name: "AWS", slug: "amazonwebservices" },
  { name: "Google Cloud", slug: "googlecloud" },
  { name: "Azure", slug: "microsoftazure" },
  { name: "Kubernetes", slug: "kubernetes" },
  { name: "Docker", slug: "docker" },
  { name: "Terraform", slug: "terraform" },
  { name: "Ansible", slug: "ansible" },
  { name: "Helm", slug: "helm" },
  { name: "Linux", slug: "linux" },
  { name: "Nginx", slug: "nginx" },
];

const ROW_2 = [
  { name: "OpenAI", slug: "openai" },
  { name: "Anthropic", slug: "anthropic" },
  { name: "Google Gemini", slug: "googlegemini" },
  { name: "Hugging Face", slug: "huggingface" },
  { name: "LangChain", slug: "langchain" },
  { name: "Pinecone", slug: "pinecone" },
  { name: "Weaviate", slug: "weaviate" },
  { name: "Vercel", slug: "vercel" },
  { name: "Cloudflare", slug: "cloudflare" },
  { name: "Supabase", slug: "supabase" },
];

const ROW_3 = [
  { name: "Python", slug: "python" },
  { name: "Node.js", slug: "nodedotjs" },
  { name: "Go", slug: "go" },
  { name: "Rust", slug: "rust" },
  { name: "Java", slug: "openjdk" },
  { name: "TypeScript", slug: "typescript" },
  { name: "React", slug: "react" },
  { name: "Next.js", slug: "nextdotjs" },
  { name: "FastAPI", slug: "fastapi" },
  { name: "Django", slug: "django" },
];

const ROW_4 = [
  { name: "PostgreSQL", slug: "postgresql" },
  { name: "MongoDB", slug: "mongodb" },
  { name: "Redis", slug: "redis" },
  { name: "Apache Kafka", slug: "apachekafka" },
  { name: "Snowflake", slug: "snowflake" },
  { name: "Databricks", slug: "databricks" },
  { name: "Elasticsearch", slug: "elasticsearch" },
  { name: "GitHub", slug: "github" },
  { name: "GitLab", slug: "gitlab" },
  { name: "Grafana", slug: "grafana" },
];

function Pill({ tech }) {
  return (
    <div
      className="flex-shrink-0 inline-flex items-center gap-3 px-5 h-14 bg-carbon border border-white/10 hover:border-neon-green/40 transition-colors"
      data-testid={`tech-${tech.slug}`}
    >
      <img
        src={`https://cdn.simpleicons.org/${tech.slug}/FFFFFF`}
        alt=""
        loading="lazy"
        className="h-6 w-6 object-contain opacity-70"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
      <span className="text-sm font-mono text-white/70 whitespace-nowrap">
        {tech.name}
      </span>
    </div>
  );
}

function Row({ items, direction = "left", duration = "40s" }) {
  const track = [...items, ...items];
  const animClass =
    direction === "left" ? "animate-marquee" : "animate-marquee-reverse";
  return (
    <div className="relative overflow-hidden">
      <div
        className={`flex w-max gap-4 ${animClass}`}
        style={{ animationDuration: duration }}
      >
        {track.map((t, i) => (
          <Pill key={`${t.slug}-${i}`} tech={t} />
        ))}
      </div>
    </div>
  );
}

export default function TechStack() {
  return (
    <section
      data-testid="tech-stack"
      className="relative border-b border-white/10 bg-obsidian overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 lg:pt-24 pb-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="chip text-neon-green">&gt; /tech_stack</div>
            <h2 className="mt-3 font-display font-black text-3xl md:text-4xl lg:text-5xl text-white tracking-tighter leading-tight">
              The stack we ship on.
            </h2>
          </div>
          <p className="max-w-md text-white/60 text-sm leading-relaxed">
            Cloud platforms, AI providers, open-source engines, data stores, and
            tooling, chosen per problem, not per preference.
          </p>
        </div>
      </div>

      {/* Marquee rows */}
      <div className="relative pb-20">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-obsidian to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-obsidian to-transparent" />

        <div className="flex flex-col gap-4">
          <Row items={ROW_1} direction="left" duration="55s" />
          <Row items={ROW_2} direction="right" duration="45s" />
          <Row items={ROW_3} direction="left" duration="60s" />
          <Row items={ROW_4} direction="right" duration="50s" />
        </div>
      </div>
    </section>
  );
}
